import fetchApi from './fetch';

export function getDailyDownloadLimit() {
  return fetchApi('/settings/daily-download-limit', 'GET');
}